import Modal from 'react-modal'
import React from 'react'
import { Button } from 'loyal-react'
import PropTypes from 'prop-types'
import './ParticipantDistributionPoint.css'
import { formatNumber } from '../../LikePlusCustom/Helpers'

const CsvModalError = ({
  modal,
  csvError,
  totalPoints,
  walletBalance,
  toggleModal
}) => {
  return (
    <Modal
      isOpen={modal}
      onRequestClose={toggleModal}
      style={{
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          width: '1000px'
        }
      }}
    >
      {
        totalPoints > walletBalance
          ? (
            <div className='row col-12 mr-auto px-3 py-2'>
              <div className='col-10 py-1'>
                <h4 className='txt-initial points-warning mr-auto'>
                  {formatNumber(totalPoints)} Pontos Utilizados / Total {formatNumber(walletBalance)}
                </h4>
              </div>
              <div className='col-2 py-1'>
                <Button
                  id='closeModal'
                  name='closeModal'
                  className='btn btn-sm mx-0'
                  text='Fechar'
                  onClick={() => toggleModal('csvModalError')}
                />
              </div>
            </div>
          ) : (
            <div className='row col-12 mr-auto px-3 py-2'>
              <div className='col-10 py-1'>
                <h4 className='txt-initial color-brand-1 mr-auto'>
                  {formatNumber(totalPoints)} Pontos Utilizados / Total {formatNumber(walletBalance)}
                </h4>
              </div>
              <div className='col-2 py-1'>
                <Button
                  id='closeModal'
                  name='closeModal'
                  className='btn btn-sm mx-0'
                  text='Fechar'
                  onClick={() => toggleModal('csvModalError')}
                />
              </div>
            </div>
          )
      }
      <div className='col-12 order-item'>
        <div className='mx-0 row px-0 border-color-ui-3 border-dotted-bottom py-2'>
          <div className='order-product-info col mr-auto'>
            <div className='order-product-info row'>
              <div className='product-infos col-1 mx-0'>
                <h3 className='txt-font-body txt-subtitle color-ui-2 mt-1 header-text-title col-12'>
                  Linha
                </h3>
              </div>
            </div>
          </div>
          <div className='order-product-info col mr-auto'>
            <div className='order-product-info row'>
              <div className='product-infos col-1 mx-0'>
                <h3 className='txt-font-body txt-subtitle color-ui-2 mt-1 header-text-title col-12'>
                  Campo
                </h3>
              </div>
            </div>
          </div>
          <div className='order-product-info col mr-auto'>
            <div className='order-product-info row'>
              <div className='product-infos col-1 mx-0'>
                <h3 className='txt-font-body txt-subtitle color-ui-2 mt-1 header-text-title col-12'>
                  Valor
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      {csvError.map((b, i) => {
        return (
          <div className='col-12 order-item'>
            <div className='mx-0 row px-0 border-color-ui-3 border-dotted-bottom py-2'>
              <div className='order-product-info col mr-auto'>
                <div className='order-product-info row'>
                  <div className='product-infos col-3 mx-0'>
                    <h4 className='txt-font-body txt-subtitle color-ui-2 mt-1 body-text-title'>
                      {b.line}
                    </h4>
                  </div>
                </div>
              </div>
              <div className='order-product-info col mr-auto'>
                <div className='order-product-info row'>
                  <div className='product-infos col-3 mx-0'>
                    <h4 className='txt-font-body txt-subtitle color-ui-2 mt-1 body-text-title'>
                      {b.type}
                    </h4>
                  </div>
                </div>
              </div>
              <div className='order-product-info col mr-auto'>
                <div className='order-product-info row'>
                  <div className='product-infos col-3 mx-0'>
                    <h4 className='txt-font-body txt-subtitle color-ui-2 mt-1 body-text-title'>
                      {b.value}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      })}
    </Modal>
  )
}

CsvModalError.propTypes = {
  modal: PropTypes.bool,
  csvError: PropTypes.array,
  totalPoints: PropTypes.number,
  walletBalance: PropTypes.number,
  toggleModal: PropTypes.func
}

export default CsvModalError



// WEBPACK FOOTER //
// ./src/features/FocalPoint/Participant/CsvModalError.js